<template>
    <v-simple-table style="background-color: #fff !important;">
        <template v-slot:default>
            <thead>
            <tr>
                <th class="text-left">Nº Factura</th>
                <th class="text-left">Descripción</th>
                <th class="text-left">Fecha Emisión</th>
                <th class="text-left">Cantidad</th>
                <th class="text-left">Estado</th>
                <th class="text-left">Acciones</th>
              <th class="text-left">Ver PDF</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="invoice in invoices" :key="invoice.invoiceID">
                <td>
                    <p v-if="invoice.invoiceNumber<10"> 0000000{{invoice.invoiceNumber}}/{{invoice.date_add.split("-")[0]}}</p>
                    <p v-if="invoice.invoiceNumber<100 && invoice.invoiceNumber>=10"> 000000{{invoice.invoiceNumber}}/{{invoice.date_add.split("-")[0]}}</p>
                    <p v-if="invoice.invoiceNumber<1000 && invoice.invoiceNumber>=109"> 00000{{invoice.invoiceNumber}}/{{invoice.date_add.split("-")[0]}}</p>
                </td>
              <td>{{invoice.name}}</td>
                <td>{{invoice.date_add}}</td>
                <td>{{getParseTotal(invoice.total)}}€</td>
                <td v-if="invoice.status==='0'" style="color:#E8AD00">Pendiente de pago</td>
                <td v-else-if="invoice.status==='1'" style="color:#217A2B">Pagada</td>
                <td>
                  <v-btn
                      v-if="invoice.status==='0'"
                      color="green lighten-3"
                      class="ma-2 white--text"
                      outlined
                      @click="setPaidInvoice(invoice.invoiceID)">
                    Marcar Pagada
                    <v-icon right dark>mdi-check</v-icon>
                  </v-btn>
                </td>
              <td> <a :href="'https://invoicer.grupowapps.es/generator/invoice/'+invoice.invoiceID+'/'+$route.params.id"
                      target="_blank" rel="nofollow">
                <v-icon>mdi-file-pdf</v-icon>
              </a></td>
            </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
    export default {
        name: "invoicesTable",
        props: ['invoices', 'refresh'],
        methods:{
          getParseTotal(total){
            return parseFloat(total).toFixed(2)
          },
            setPaidInvoice(iid){
                this.loaded = false;
                let url = this.base_url + '/api/admin/paidinvoice';
                let formData = new FormData();
                formData.set('token', localStorage.token);
                formData.set('invoiceID', iid);
                this.axios.post(url,formData).then(() => {
                    this.refresh();
                });
            }
        }
    }
</script>

<style scoped>

</style>